export default __webpack_public_path__ + "static/media/privacy-policy-title-id.57b4ec5c.webp";